export default function Hero() {
  return (
    <section className="relative h-[60vh] min-h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://ik.imagekit.io/pianomoverslondon/tr:w-1200,h-800,c-at_max,q-85,f-webp/Piano%20Removals%20Gallery%20London%20Jobs/Piano_Removals_London_Pictures_from_job%20(3).jpeg"
          alt="Piano removal London — professional team with specialist equipment"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto w-full">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-4 drop-shadow-lg">
          Piano Removal Cost London — 2026 Price Guide
        </h1>
        <p className="text-lg md:text-xl text-white/95 font-light max-w-2xl mx-auto drop-shadow-md">
          Everything you need to know about piano removal prices in London
        </p>
      </div>
    </section>
  );
}